






















































































































































































import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { NormsServices } from '../api/NormsServices';
import Loading from 'vue-loading-overlay';
import $ from 'jquery';
import { getIndexFromList } from '../../core/utils';

@Component({
    components: {}
})
export default class PreviewEcu extends Vue {
    @Prop() previewData: any;
    @Prop() previewPatch: boolean;
    @Prop() currentAction: string;
    @Prop() previewFromList: boolean;
    @Prop() postData: any;
    insidePanel: any = 0;
    panel: any = 0;
    sectionNames: any = [];
    model: any = [];
    // previewData: any = [];

    @Emit()
    backToList() {}

    @Emit()
    prevStep() {}

    mounted() {
        if (!this.previewPatch) {
            this.sectionNames = [
                {
                    id: 'active_files',
                    name: 'Presente en Normas'
                },
                {
                    id: 'ecu_definition',
                    name: 'Configuración Inicial'
                },
                {
                    id: 'categories',
                    name: 'Categorías'
                },
                {
                    id: 'frames',
                    name: 'Frames'
                }
            ];
        } else {
            this.sectionNames = [
                {
                    id: 'categories',
                    name: 'Categorías'
                },
                {
                    id: 'frames',
                    name: 'Frames'
                },
                {
                    id: 'parameters',
                    name: 'Parámetros'
                }
            ];
        }
    }

    getHeaderName(key, values) {
        if (key === 'ecu_definition' || key === 'protocol') {
            return this.getSectionName(key);
        } else if (key === 'parameters') {
            if (values !== undefined && values.length > 0) {
                return 'Parámetros ' + ' (' + values.length + ')';
            } else {
                return 'Parámetros';
            }
        }
        {
            if (values !== undefined && values.length > 0) {
                return this.getSectionName(key) + ' (' + values.length + ')';
            } else {
                return this.getSectionName(key);
            }
        }
    }

    getHeaderNamePatch(key) {
        return this.getSectionName(key);
    }

    getSectionName(i) {
        let index = getIndexFromList(this.sectionNames, 'id', i);

        if (index !== -1) {
            return this.sectionNames[index]['name'];
        }
    }

    triggerActionBack() {
        if (!this.previewFromList || this.previewPatch) {
            this.prevStep();
        } else {
            this.backToList();
        }
    }

    close() {
        this.model = [];
    }
}
